import { gql } from '@apollo/client'

import { LOCATION_ADDRESS_FRAGMENT } from './location/address'

export const LOCATION_FRAGMENT = gql`
  fragment Location on Location {
    attire
    id
    name
    primaryEmail
    timezone
    canSubscribeViaSms
    address {
      ...LocationAddress
    }
  }
  ${LOCATION_ADDRESS_FRAGMENT}
`
